import React from 'react';

import trash from '../../../images/trash_can.svg';

import { FOHImage } from '../../ingredients';

export const FOHTrashCan = (props: any) => (
  <FOHImage
    source={{ uri: trash }}
    style={{ width: 16, height: 16, ...props?.style }}
  />
);
